import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import SoftBadge from 'components/common/SoftBadge';

const LeadsLiberados = ({ 
    lista3LeadsLiberados, 
    tags,
    cargando, 
    setIdLead, 
    setShowModal,
    leadsLiberados 
}) => {
    return (
        <Col className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <Row>
                <Col className="col-12 ms-2">
                    <Row>
                        <Col className="col-12 fs--1">
                            {cargando ? (
                                <Skeleton />
                            ) : (
                                <>
                                    <label className="muted">Leads Liberados: &nbsp;</label>
                                    <Link to={"#"} onClick={() => leadsLiberados()}>
                                        Ver Leads Liberados
                                    </Link>
                                </>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {cargando ? (
                                <Row>
                                    <Col className="col-4"><Skeleton height={100} /></Col>
                                    <Col className="col-4"><Skeleton height={100} /></Col>
                                    <Col className="col-4"><Skeleton height={100} /></Col>
                                </Row>
                            ) : lista3LeadsLiberados.length > 0 ? (
                                <Row>
                                    {lista3LeadsLiberados.map((lead, index) => (
                                        <LeadLiberadoCard
                                            key={index}
                                            lead={lead}
                                            tags={tags}
                                            setIdLead={setIdLead}
                                            setShowModal={setShowModal}
                                        />
                                    ))}
                                </Row>
                            ) : (
                                <label className="fw-bold text-danger">
                                    Ningún Lead liberado disponible
                                </label>
                            )}
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Col>
    );
};

const LeadLiberadoCard = ({ lead, tags, setIdLead, setShowModal }) => {
    const objTag = JSON.parse(lead.vJsonTags);

    return (
        <Col className="h-100 mt-2 fs--2 col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 p-0">
            <Link className="m-0" to={"#"} onClick={() => { setIdLead(lead.idLead); setShowModal(true); }}>
                <Row>
                    <Col className="col-12 text-900 fw-semi-bold">
                        <img width="25" src="/img/cliente48.png" alt="cliente" />
                        &nbsp;{"Lead " + lead.idLead}
                    </Col>
                    <Col className="col-12 fw-medium text-600">
                        {lead.vNombreLead.length > 13 
                            ? lead.vNombreLead.substring(0, 13) + "..." 
                            : lead.vNombreLead.length > 0 
                                ? lead.vNombreLead 
                                : "Lead #" + lead.idLead
                        }
                    </Col>
                    <Col className="col-12">
                        <SoftBadge 
                            pill 
                            bg={
                                lead.idEtapa === 1 ? "secondary" :
                                lead.idEtapa === 2 ? "primary" :
                                lead.idEtapa === 3 ? "warning" :
                                lead.idEtapa === 4 ? "success" :
                                lead.idEtapa === 5 ? "danger" :
                                lead.idEtapa === 6 ? "warning" : "success"
                            }
                            className="mt-1"
                        >
                            {lead.vNombreEtapa}
                        </SoftBadge>
                    </Col>
                    <Col className="col-12">
                        <SoftBadge
                            bg={
                                lead.iDaysDiff >= 0 && lead.iDaysDiff < 3 ? "success" :
                                lead.iDaysDiff >= 3 && lead.iDaysDiff < 5 ? "warning" : "danger"
                            }
                        >
                            {lead.iDaysDiff + " días sin actualizaciones"}
                        </SoftBadge>
                    </Col>
                    <Col className="col-12">
                        <span>
                            {objTag.map((tag, index) => {
                                const objDDLTag = tags.find(t => t.idLeadTag === tag.idLeadTag);
                                return objDDLTag ? (
                                    <OverlayTrigger 
                                        key={index} 
                                        placement="left" 
                                        overlay={
                                            <Tooltip id="tooltip">
                                                <strong>{objDDLTag.vNombreTag}</strong>
                                            </Tooltip>
                                        }
                                    >
                                        <span style={{ cursor: 'pointer' }}>
                                            <SoftBadge
                                                className={"me-1 bgTag_" + index}
                                                bg={objDDLTag.colorActive}
                                            >
                                                {objDDLTag.vAbreviacionTag}
                                            </SoftBadge>
                                        </span>
                                    </OverlayTrigger>
                                ) : null;
                            })}
                        </span>
                    </Col>
                </Row>
            </Link>
        </Col>
    );
};

LeadsLiberados.propTypes = {
    lista3LeadsLiberados: PropTypes.array.isRequired,
    tags: PropTypes.array.isRequired,
    cargando: PropTypes.bool.isRequired,
    setIdLead: PropTypes.func.isRequired,
    setShowModal: PropTypes.func.isRequired,
    leadsLiberados: PropTypes.func.isRequired
};

LeadLiberadoCard.propTypes = {
    lead: PropTypes.object.isRequired,
    tags: PropTypes.array.isRequired,
    setIdLead: PropTypes.func.isRequired,
    setShowModal: PropTypes.func.isRequired
};

export default LeadsLiberados;
